import { render, staticRenderFns } from "./Screens.vue?vue&type=template&id=3583fcd8"
import script from "./Screens.vue?vue&type=script&lang=js"
export * from "./Screens.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports